var _desc;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMasonStraightOpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 686,
    height: 753,
    viewBox: "28 20 686 753",
    overflow: "hidden",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "mason_straight.DXF - scale = 25.400000, origin = (0.000000, 0.000000), method = manual")), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 4,
      strokeDasharray: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2533.1 4731.26v-2304m-768 0v2304m0-192h768m-768 192h768m-768-384h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m-768-192h768m288 2088v144m0-432v144m0-288 72 72m-72-216v144m288 648v-2304m-216 1728-72 72m72 216-72 72m72-648-72 72m0-144 72 72m0-1152-72 72m0 0v144m0 0 72 72m-72 1368 72 72m-72-1368v144m72-792h216m0 2304h-216m-72-72 72 72m0-2304-72 72m0 0v144m0 0 72 72m-72 504 72 72m0 0-72 72m0 0v144m72-504-72 72m72 504-72 72m0 0v144m0-288 72 72m-1416-1080v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0 0 72 72m0 0v144m0 0-72 72m0-2304 72 72m-288 2232v-2304m0 2304h216m-216-2304h216",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeDasharray: "none"
    },
    transform: "matrix(0.3238,0,0,0.3238,-295.23858,-762.26322)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.196 738.61v-29.906h244.812v59.812H278.196Zm0-62.594V646.11h244.812v59.812H278.196Zm0-61.899v-29.21h244.812v58.42H278.196Zm0-61.899v-29.906h244.812v59.813H278.196Zm0-62.594v-29.906h244.812v59.812H278.196Zm0-61.898v-29.21h244.812v58.42H278.196Zm0-61.899v-29.906h244.812v59.812H278.196Zm0-62.594v-29.906h244.812v59.812H278.196Zm0-61.898v-29.21h244.812v58.42H278.196Zm0-61.899V149.53h244.812v59.812H278.196Zm0-62.594V86.936h244.812v59.812H278.196Zm0-62.594V24.342h244.812v59.812H278.196Z",
    style: {
      fill: "#b3b3b3",
      stroke: "#000000",
      strokeWidth: 5.56391,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.805 396.429V24.342h66.129l12.142 12.199 12.142 12.198v43.127l-11.823 11.762c-6.503 6.469-11.823 12.415-11.823 13.214s5.32 6.745 11.823 13.214l11.823 11.762v43.244l-11.823 11.761c-6.503 6.47-11.823 12.416-11.823 13.215s5.32 6.745 11.823 13.214l11.823 11.762v43.243l-11.823 11.762c-6.503 6.47-11.823 12.415-11.823 13.214s5.32 6.746 11.823 13.215l11.823 11.762v43.973l-12.08 12.532-12.082 12.532 12.081 12.137 12.081 12.138v44.4l-12.142 12.2-12.142 12.198 12.142 12.199 12.142 12.198v44.401l-12.142 12.199-12.142 12.198 12.142 12.2 12.142 12.198v44.4l-12.142 12.2-12.142 12.198 12.142 12.199 12.142 12.198v44.518l-11.504 11.445-11.505 11.445H91.805ZM630.43 757.011l-11.445-11.505v-44.398l12.142-12.198 12.143-12.199-12.143-12.199-12.142-12.198v-44.518l11.824-11.762c6.503-6.469 11.823-12.472 11.823-13.34 0-.867-5.32-6.685-11.823-12.928l-11.824-11.35V514.6l11.824-11.762c6.503-6.47 11.823-12.416 11.823-13.215s-5.32-6.745-11.823-13.214l-11.824-11.762v-43.243l11.824-11.762c6.503-6.469 11.823-12.415 11.823-13.214s-5.32-6.745-11.823-13.214l-11.824-11.762V328.21l11.824-11.762c6.503-6.47 11.823-12.416 11.823-13.215s-5.32-6.745-11.823-13.214l-11.824-11.762v-43.243l11.824-11.762c6.503-6.469 11.823-12.415 11.823-13.214s-5.32-6.745-11.823-13.215l-11.824-11.761v-43.244l11.824-11.762c6.503-6.469 11.823-12.415 11.823-13.214s-5.32-6.745-11.823-13.214l-11.824-11.762V48.739l12.143-12.198 12.142-12.199h67.52v744.174h-68.915z",
    style: {
      fill: "#a02c2c",
      stroke: "#a02c2c",
      strokeWidth: 5.56391,
      strokeDasharray: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonStraightOpt);
export default __webpack_public_path__ + "static/media/mason_straight_opt.6b22c2ff8a2207ef4a13efd4ea635b76.svg";
export { ForwardRef as ReactComponent };